import { CookieWarning } from './ui/CookieWarning.jsx'
import './ui/CookieWarning.scss'
export default CookieWarning
